Set.prototype.filter = function <T>(
  this: Set<T>,
  predicate: (value: T) => boolean
): Set<T> {
  const result = new Set<T>();
  for (const value of this) {
    if (predicate(value)) {
      result.add(value);
    }
  }
  return result;
};
export {};
